(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["boo-home"] && !Shopify.designMode) return;
  try {
    
  function initBooHome() {
    document.querySelectorAll('.boo-home').forEach((home) => {
      if (home.dataset.ready) return;
      home.dataset.ready = 'true';
      const applyFilters = () => {
        const typeButton = home.querySelector('[data-boo-filter][aria-pressed="true"]');
        const audienceButton = home.querySelector('[data-boo-audience-filter][aria-pressed="true"]');
        const category = typeButton.dataset.booFilter;
        const audience = audienceButton.dataset.booAudienceFilter;
        let count = 0;
        home.querySelectorAll('[data-boo-category]').forEach((item) => {
          const categoryMatches = category === 'all' || item.dataset.booCategory === category;
          const audienceMatches = audience === 'all' || item.dataset.booAudience === 'both' || item.dataset.booAudience === audience;
          item.hidden = !categoryMatches || !audienceMatches;
          if (!item.hidden) count++;
        });
        home.querySelector('[data-boo-empty]').hidden = count > 0;
        home.querySelector('[data-boo-filter-status]').textContent = typeButton.textContent.trim() + ' · ' + audienceButton.textContent.trim() + ': ' + count;
        document.dispatchEvent(new Event('boo:filters:change'));
      };
      ['data-boo-filter', 'data-boo-audience-filter'].forEach((attribute) => {
        home.querySelectorAll('[' + attribute + ']').forEach((button) => button.addEventListener('click', () => {
          home.querySelectorAll('[' + attribute + ']').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
          applyFilters();
        }));
      });
      home.querySelectorAll('[data-boo-open]').forEach((button) => button.addEventListener('click', () => {
        const dialog = document.getElementById(button.dataset.booOpen);
        dialog.showModal();
      }));
      home.querySelectorAll('.boo-outfit-dialog').forEach((dialog) => {
        dialog.querySelector('[data-boo-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
      });
    });
  }
  initBooHome();
  document.addEventListener('shopify:section:load', initBooHome);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
